import * as React from "react";

interface ImpersonationContextValue {
  isSupport: boolean;
  isImpersonating: boolean;
  impersonatedBy: string | null;
}

export const ImpersonationContext =
  React.createContext<ImpersonationContextValue>({
    isSupport: false,
    isImpersonating: false,
    impersonatedBy: null,
  });

export function useImpersonationContext() {
  return React.useContext(ImpersonationContext);
}
